function users(state = {}, action) {
    switch(action.type) {
        case 'USERS_FETCH_START':
            return {
                data : [],
                fetching : true,
                error : null,
            }
        case 'USERS_FETCH_SUCCESS':
            return {
                data : action.data,
                fetching : false,
                error : null,
            }
        case 'USERS_FETCH_FAILURE':
            return {
                data : [],
                fetching : false,
                error : action.error,   
            }
        case 'USERS_SAVE_SUCCESS' :
            const user = action.data;
            const data = state.data || [];
            let found = false;
            const newData = data.map(usr => {
                if(parseInt(usr.id, 10) === parseInt(user.id, 10)){
                    found = true;
                    return user;
                } 
                return usr;
            });
            if(!found) {
                newData.push(user);
            }
            return {
                ...state,
                savedUser : user,
                data : newData
            }
        case 'USERS_SAVE_FAILURE' :
            return {
                ...state,
                error : action.error
            }
        case 'USERS_CLEAR_SAVE_DATA' :
            return {
                ...state,
                error : null,
                savedUser : null,
            }
        case 'USER_DELETE_START' : 
            return {
                ...state,
                deleting : true
            }
        case 'USER_DELETE_FAILURE' :
            return {
                ...state,
                deleting : false,
                error : action.error
            }
        case 'USER_DELETE_SUCCESS' : 
            return {
                ...state,
                deleting : false,
                error : null,
                data : (state.data || []).filter(usr => action.data.id !== usr.id)
            }
        default :
            return state;        
    }
}


export default users;


/** WEBPACK FOOTER **
 ** ./src/reducers/users.js
 **/